import {Component, OnInit} from '@angular/core';
import {AlertListService, QueryStringService} from '@xref/ngx';
import {Router} from '@angular/router';
import constants from 'src/app/shared/constants';
import {JwtHelperService} from '@auth0/angular-jwt';
import {environment} from 'src/environments/environment';
import {RegisterService} from 'src/app/services/register/register.service';
import {MarketingService} from 'src/app/services/marketing/marketing.service';
import * as Cookies from 'js-cookie';
import {IdService} from "../../services/id/id.service";

@Component({
    selector: 'xlog-verify-account',
    templateUrl: './verify-account.component.pug',
    styleUrls: ['./verify-account.component.scss'],
    standalone: false
})
export class VerifyAccountComponent implements OnInit {
    xrefRegisterToken = '';
    regionParam = '';

    verifyFailed = false;

    email: '';

    constructor(
        private qs: QueryStringService,
        private router: Router,
        private reg: RegisterService,
        private id: IdService,
        private jwtHelper: JwtHelperService,
        private alertList: AlertListService,
        private marketing: MarketingService
    ) {}

    ngOnInit() {
        this.marketing.setMarketingResource('register-marketing-section');

        this.setRegion();

        this.hasXrefRegisterToken();

        this.verify();
    }

    setRegion() {
        this.regionParam = this.qs.getParam('region');
        Cookies.set(constants.API_REGION_TOKEN, this.regionParam, {domain: environment.DOMAIN});
        this.reg.setRegionalUrl(this.regionParam);
    }

    hasXrefRegisterToken() {
        const token = this.qs.getParam('xrt');

        if (token)
            this.xrefRegisterToken = token;
        else
            this.router.navigate(['/']);
    }

    verifySuccess = (data) => {
        if (this.id.ent_9105) {
            this.id.setSessionToken(constants.AUTH_TOKEN, data.token);
            this.id.setToken(constants.TRACKING_ID, this.jwtHelper.decodeToken(data.token).user_id);
            this.id.redirectToReturnUrl(environment.APP_URL);
        } else {
            this.id.setToken(constants.AUTH_TOKEN, data.token);
            this.id.setToken(constants.TRACKING_ID, this.jwtHelper.decodeToken(data.token).user_id);
            this.id.DeprecatedRedirectToReturnUrl(environment.APP_URL);
        }
    };

    verifyError = (err) => {
        this.verifyFailed = true;
    };

    verify() {
        this.reg.verifyAccount(this.xrefRegisterToken).subscribe(
            this.verifySuccess,
            this.verifyError
        );
    }

    resendLinkSuccess = () => {
        this.alertList.append([{active: true, type: 'success', messageKey: 'verifyAccount.resendLink.success.label'}]);
    };

    resendLinkError = () => {
        this.alertList.append([{active: true, type: 'danger', messageKey: 'alerts.generic.error'}]);
    };

    resendLink() {
        this.reg.resendLinkByToken(this.xrefRegisterToken).subscribe(
            this.resendLinkSuccess,
            this.resendLinkError
        );
    }
}
